import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ArrowDoubleRightSvg = function ArrowDoubleRightSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 3.022 12.078 12 3 20.978 4.034 22l10.112-10L4.034 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.854 3.022 18.932 12l-9.078 8.978L10.888 22 21 12 10.888 2z"
  }));
};
export var ArrowDoubleRight = function ArrowDoubleRight(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ArrowDoubleRightSvg
  }));
};